import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

import { MyTeamResponse } from '../model/types';

export const getTeamData = async () => {
    // @ts-ignore
    const getMyTeamUrl = routable.getRoute('getMyTeam');

    try {
        const res = await $api.get<IDataResponse<MyTeamResponse>>(`${getMyTeamUrl}`);

        return res.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error);
        return error.message;
    }
};
